import router from "./router";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import getPageTitle from "@/utils/get-page-title";

NProgress.configure({ showSpinner: false });
let whiteUrlList = [
  "/",
  "/openList",
  "/nameList",
  "/alarmConfig",
  "/floorPlan",
  "/testIndex",
  "/projectConfig",
  "/test",
  "/audioPackage",
  "/elevatorControl",
];

router.beforeEach((to, from, next) => {
  NProgress.start();

  document.title =
    process.env.VUE_APP_OPEN_CONFIG_TITLE || getPageTitle(to.meta.title);

  if (whiteUrlList.indexOf(to.path) !== -1) {
    next();
  } else {
    next(`/`);
    NProgress.done();
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
